import {
  ActionIcon,
  Button,
  Group,
  NumberFormatter,
  Stack,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { IconEdit, IconFolder } from "@tabler/icons-react";
import { useState } from "react";
import { deletePool, editPool } from "../../../../../api/EmailAPI";
import { deleteFolder, editFolder } from "../../../../../api/FolderAPI";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useNavigate, useParams } from "react-router-dom";
import ItemDeleter from "../../../../../components/TableComponents/ItemDeleter";
import PopOver from "../../../../../components/View/PopOver";

const FolderItem = ({
  folder,
  isPool,
  setOpened,
  setLoading,
  getClickLink,
  getDeletedLink,
}) => {
  const lang = useLanguage(s => s.language)
  const { folderId, poolId } = useParams();

  const navigate = useNavigate();
  const handleClick = (newFolder) => {
    navigate(getClickLink(newFolder.id));
    setOpened(false);
  };

  const onDeleted = () => {
    if (isPool) {
      if (parseInt(poolId) === folder.id) {
        navigate(getDeletedLink());
      }
    } else {
      if (parseInt(folderId) === folder.id) {
        navigate(getDeletedLink());
      }
    }
    setOpened(false);
  };

  const onEdited = () => {
    setLoading(true);
  };

  return (
    <Button
      component="div"
      key={folder.id}
      variant={
        folderId === folder.id.toString() || poolId === folder.id.toString()
          ? "filled"
          : "subtle"
      }
      leftSection={<IconFolder size={18} />}
      onClick={(e) => {
        e.stopPropagation();
        handleClick(folder);
      }}
      justify="start"
    >
      {folder.name}

      <Group
        pos={"absolute"}
        right={8}
        gap={"xs"}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Text>
          <NumberFormatter value={folder.number_of_items} />
        </Text>
        <RenameFolder item={folder} isPool={isPool} onEdited={onEdited} />
        <ItemDeleter
          id={folder.id}
          handleDelete={isPool ? deletePool : deleteFolder}
          onFinish={onDeleted}
          deletedMessage={isPool ? "Pool supprimé" : lang.components.folder_navigator.delete_success}
          title_bold={folder.name}
          variant="white"
        />
      </Group>
    </Button>
  );
};

const RenameFolder = ({ item, isPool, onEdited }) => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(false);

  const handleSubmit = (e, handleClose) => {
    e.preventDefault();

    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    const main = isPool ? editPool : editFolder;
    main({ name: data.name, id: item.id })
      .then(() => {
        onEdited?.();
        handleClose?.();
      })
      .finally(() => setLoading(false));
  };

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Tooltip
          label={
            isPool
              ? lang.pools.edit.button_tooltip
              : lang.components.folder_navigator.edit_title
          }
          withArrow
        >
          <ActionIcon
            variant="white"
            onClick={(e) => {
              e.preventDefault();
              handleOpen(e);
            }}
            ref={ref}
          >
            <IconEdit size={16} />
          </ActionIcon>
        </Tooltip>
      )}
      popoverChildren={(handleClose) => (
        <Stack
          component={"form"}
          onSubmit={(e) => handleSubmit(e, handleClose)}
          w={200}
          gap={0}
        >
          <TextInput
            label={
              isPool
                ? lang.pools.create.dialog.name
                : lang.components.folder_navigator.create.name
            }
            placeholder={
              isPool
                ? lang.pools.create.dialog.name
                : lang.components.folder_navigator.create.name
            }
            defaultValue={item.name}
            name="name"
            data-autoFocus
            required
          />

          <Group justify="end">
            <Button
              loading={loading}
              variant="light"
              type="submit"
              w={"100%"}
              mt={"xs"}
            >
              {lang.components.folder_navigator.edit_title}
            </Button>
          </Group>
        </Stack>
      )}
    />
  );
};

export default FolderItem;
